import React from "react";
import zero from '../img/zero.gif';
import { Link } from "react-router-dom";

const CompanyOne = () => {
    return (
        <section className="py-0 position-relative overflow-hidden" style={{ backgroundColor: '#f8f9fa' }}>
            <div className="position-absolute top-0 start-0 w-100 h-100 overflow-hidden">
                <div className="position-absolute top-0 end-0 w-96 h-96 rounded-full opacity-10"
                    style={{ 
                        backgroundColor: '#ff2222',
                        animation: "floatSlow 25s ease-in-out infinite" 
                    }}></div>
                <div className="position-absolute bottom-0 start-20 w-80 h-80 rounded-full opacity-10"
                    style={{ 
                        backgroundColor: '#ff4444',
                        animation: "floatSlow 30s ease-in-out infinite 3s" 
                    }}></div>
            </div>

            <div className="container py-4 py-lg-5 position-relative">
                <div className="row align-items-center min-vh-70 min-vh-lg-80">
                    <div className="col-12">

                        <div className="text-center">
                            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                                <Link to="/Contactus" className="btn btn-lg px-5 py-3 rounded-3xl fw-bold shadow-lg transition-all duration-300"
                                    style={{ backgroundColor: '#ff2222', borderColor: '#ff2222', color: 'white' }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-3px) scale(1.05)';
                                        e.currentTarget.style.boxShadow = '0 15px 30px rgba(255, 34, 34, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                                    }}>
                                    Start Your Insurance Career Now <i className="bi bi-arrow-right ms-2"></i>
                                </Link>
                            </div>
                        </div>

                        <br />

                        <h1 className="display-4 display-lg-2 fw-bold lh-1 mb-5 text-center" style={{ color: '#333' }}>
                            Why Smart People Are Choosing an
                        </h1>

                        <h2 className="display-6 display-lg-2 fw-bold lh-1 mb-5 text-center" style={{ color: '#333', marginTop:'-30px' }}> 
                            <span style={{ color: '#ff2222' }}>Insurance Agent Career in India</span> 
                        </h2>

                        {/* First Row - Cards with white background */}
                        <div className="row g-3 mb-5">
                            <div className="col-12 col-md-4 d-flex">
                                <div className="bg-white border rounded-3xl p-4 w-100 shadow-hover transition-all duration-300 d-flex flex-column"
                                    style={{ 
                                        borderColor: 'rgba(255, 34, 34, 0.2)', 
                                        minHeight: '200px',
                                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(255, 34, 34, 0.2)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.5)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.2)';
                                    }}>
                                    <div style={{ color: '#ff2222' }} className="fs-3 mb-2">👑</div>
                                    <h5 className="fw-bold mb-1" style={{ color: '#ff2222' }}>Be Your Own Boss</h5>
                                    <p className="mb-0" style={{ color: 'black', fontSize: '1.05rem', lineHeight: '1.6' }}>Take control of your career and work independently</p>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 d-flex">
                                <div className="bg-white border rounded-3xl p-4 w-100 shadow-hover transition-all duration-300 d-flex flex-column"
                                    style={{ 
                                        borderColor: 'rgba(255, 34, 34, 0.2)', 
                                        minHeight: '200px',
                                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(255, 34, 34, 0.2)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.5)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.2)';
                                    }}>
                                    <div style={{ color: '#ff2222' }} className="fs-3 mb-2">💰</div>
                                    <h5 className="fw-bold mb-1" style={{ color: '#ff2222' }}>Unlimited Income</h5>
                                    <p className="mb-0" style={{ color: 'black', fontSize: '1.05rem', lineHeight: '1.6' }}>Earn high commissions with lifetime renewals</p>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 d-flex">
                                <div className="bg-white border rounded-3xl p-4 w-100 shadow-hover transition-all duration-300 d-flex flex-column"
                                    style={{ 
                                        borderColor: 'rgba(255, 34, 34, 0.2)', 
                                        minHeight: '200px',
                                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(255, 34, 34, 0.2)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.5)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.2)';
                                    }}>
                                    <div style={{ color: '#ff2222' }} className="fs-3 mb-2">🤝</div>
                                    <h5 className="fw-bold mb-1" style={{ color: '#ff2222' }}>Work on Your Terms</h5>
                                    <p className="mb-0" style={{ color: 'black', fontSize: '1.05rem', lineHeight: '1.6' }}>Help families stay protected while enjoying flexibility</p>
                                </div>
                            </div>
                        </div>

                        {/* Second Row - Cards with white background */}
                        <div className="row g-3 mb-5">
                            <div className="col-12 col-md-4 d-flex">
                                <div className="bg-white border rounded-3xl p-4 w-100 text-center shadow-hover transition-all duration-300 d-flex flex-column align-items-center justify-content-center"
                                    style={{ 
                                        borderColor: 'rgba(255, 34, 34, 0.2)', 
                                        minHeight: '200px',
                                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(255, 34, 34, 0.3)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.2)';
                                    }}>
                                    <div className="mb-3">
                                        <img
                                            src={zero}
                                            alt="Zero Investment"
                                            className="img-fluid"
                                            style={{
                                                width: '80px',
                                                height: '80px',
                                                objectFit: 'contain',
                                                display: 'block',
                                                margin: '0 auto',
                                                borderRadius: '16px'
                                            }}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                console.error('Image failed to load:', zero);
                                            }}
                                        />
                                    </div>
                                    <h5 className="fw-bold mb-1" style={{ color: '#ff2222' }}>Zero Investment</h5>
                                    <p className="mb-0" style={{ color: 'black', fontSize: '1.05rem', lineHeight: '1.6' }}>Start your career with no upfront costs</p>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 d-flex">
                                <div className="bg-white border rounded-3xl p-4 w-100 text-center shadow-hover transition-all duration-300 d-flex flex-column align-items-center justify-content-center"
                                    style={{ 
                                        borderColor: 'rgba(255, 34, 34, 0.2)', 
                                        minHeight: '200px',
                                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(255, 34, 34, 0.3)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.2)';
                                    }}>
                                    <div className="display-5 display-lg-4 fw-bold mb-2" style={{ color: '#ff2222' }}>18+</div>
                                    <h5 className="fw-bold mb-1" style={{ color: '#ff2222' }}>Minimum Age</h5>
                                    <p className="mb-0" style={{ color: 'black', fontSize: '1.05rem', lineHeight: '1.6' }}>Anyone 18 or above can start this career</p>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 d-flex">
                                <div className="bg-white border rounded-3xl p-4 w-100 text-center shadow-hover transition-all duration-300 d-flex flex-column align-items-center justify-content-center"
                                    style={{ 
                                        borderColor: 'rgba(255, 34, 34, 0.2)', 
                                        minHeight: '200px',
                                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(255, 34, 34, 0.3)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                                        e.currentTarget.style.borderColor = 'rgba(255, 34, 34, 0.2)';
                                    }}>
                                    <div className="display-6 fw-bold mb-2" style={{ color: '#ff2222' }}>Lifetime</div>
                                    <h5 className="fw-bold mb-1" style={{ color: '#ff2222' }}>Renewal Income</h5>
                                    <p className="mb-0" style={{ color: 'black', fontSize: '1.05rem', lineHeight: '1.6' }}>Earn passive income through policy renewals</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CompanyOne;


